/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ team: NonNullable<unknown> }} Admin_Delete_Team_ConfirmInputs */

const th_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ลบ ${i?.team} หรือไม่ รายชื่อผู้เล่น ทีมงานผู้ฝึกสอน และการสมัครแข่งขันจะถูกลบไปด้วย และไม่สามารถกู้คืนได้`)
};

const en_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.team}? Its roster, coaching staff and event entries go with it. This cannot be undone.`)
};

const ja_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} を削除しますか？ロースター、コーチングスタッフ、大会への申込も削除され、元に戻せません。`)
};

const zh_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除 ${i?.team}？阵容、教练组和报名信息会一并消失。此操作无法撤销。`)
};

const es_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.team}? Su plantilla, cuerpo técnico e inscripciones se eliminan con él. Esto no se puede deshacer.`)
};

const pt_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluir ${i?.team}? O elenco, a comissão técnica e as inscrições vão junto. Isso não pode ser desfeito.`)
};

const id_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hapus ${i?.team}? Skuad, staf pelatih dan pendaftarannya ikut terhapus. Ini tidak bisa dibatalkan.`)
};

const fr_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.team} ? Son effectif, son staff et ses inscriptions partent avec. C’est irréversible.`)
};

const tl_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Burahin ang ${i?.team}? Kasama ang squad, coaching staff at mga rehistrasyon. Hindi ito maibabalik.`)
};

const vi_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá ${i?.team}? Đội hình, ban huấn luyện và các đăng ký cũng mất theo. Không thể hoàn tác.`)
};

const ko_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team}을(를) 삭제할까요? 선수단, 코칭스태프, 등록 정보도 함께 사라집니다. 되돌릴 수 없습니다.`)
};

const de_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} löschen? Kader, Trainerstab und Anmeldungen gehen mit. Das lässt sich nicht rückgängig machen.`)
};

const ru_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалить ${i?.team}? Состав, тренерский штаб и заявки исчезнут вместе с ней. Это необратимо.`)
};

const tr_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} silinsin mi? Kadro, teknik ekip ve kayıtlar da gider. Bu geri alınamaz.`)
};

const it_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminare ${i?.team}? Spariscono anche rosa, staff tecnico e iscrizioni. L'operazione è irreversibile.`)
};

const pl_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usunąć ${i?.team}? Znikną też skład, sztab i zgłoszenia. Tego nie da się cofnąć.`)
};

const uk_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Видалити ${i?.team}? Склад, тренерський штаб і заявки зникнуть разом із нею. Це незворотно.`)
};

const hi_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} को हटाएँ? टीम, कोचिंग स्टाफ़ और पंजीकरण भी चले जाएँगे। इसे पलटा नहीं जा सकता।`)
};

const ar_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`حذف ${i?.team}؟ ستُحذف معه التشكيلة والجهاز الفني والتسجيلات. لا يمكن التراجع عن ذلك.`)
};

const ms_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Padam ${i?.team}? Skuad, kakitangan kejurulatihan dan pendaftaran turut hilang. Tindakan ini tidak boleh dibatalkan.`)
};

const bn_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team}-কে মুছবেন? দল, কোচিং স্টাফ ও নিবন্ধনও চলে যাবে। এটি ফেরানো যাবে না।`)
};

const zh_tw2_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刪除 ${i?.team}？名單、教練團與報名資料都會一併消失。此操作無法復原。`)
};

const zh_hk2_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`刪除 ${i?.team}？名單、教練團與報名資料都會一併消失。此操作無法復原。`)
};

const ur_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} کو حذف کریں؟ اسکواڈ، کوچنگ اسٹاف اور رجسٹریشن بھی ختم ہو جائیں گے۔ اسے واپس نہیں کیا جا سکتا۔`)
};

const fa_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} حذف شود؟ فهرست تیم، کادر فنی و ثبت‌نام‌ها هم از بین می‌روند. این کار برگشت‌پذیر نیست.`)
};

const sw_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Futa ${i?.team}? Kikosi, wakufunzi na usajili vitaondoka pia. Hili haliwezi kutenduliwa.`)
};

const nl_admin_delete_team_confirm = /** @type {(inputs: Admin_Delete_Team_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.team} verwijderen? Selectie, technische staf en inschrijvingen gaan mee. Dit kan niet ongedaan worden gemaakt.`)
};

/**
* | output |
* | --- |
* | "Delete {team}? Its roster, coaching staff and event entries go with it. This cannot be undone." |
*
* @param {Admin_Delete_Team_ConfirmInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_delete_team_confirm = /** @type {((inputs: Admin_Delete_Team_ConfirmInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Delete_Team_ConfirmInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_delete_team_confirm(inputs)
	if (locale === "ja") return ja_admin_delete_team_confirm(inputs)
	if (locale === "zh") return zh_admin_delete_team_confirm(inputs)
	if (locale === "es") return es_admin_delete_team_confirm(inputs)
	if (locale === "pt") return pt_admin_delete_team_confirm(inputs)
	if (locale === "id") return id_admin_delete_team_confirm(inputs)
	if (locale === "fr") return fr_admin_delete_team_confirm(inputs)
	if (locale === "tl") return tl_admin_delete_team_confirm(inputs)
	if (locale === "vi") return vi_admin_delete_team_confirm(inputs)
	if (locale === "ko") return ko_admin_delete_team_confirm(inputs)
	if (locale === "de") return de_admin_delete_team_confirm(inputs)
	if (locale === "ru") return ru_admin_delete_team_confirm(inputs)
	if (locale === "tr") return tr_admin_delete_team_confirm(inputs)
	if (locale === "it") return it_admin_delete_team_confirm(inputs)
	if (locale === "pl") return pl_admin_delete_team_confirm(inputs)
	if (locale === "uk") return uk_admin_delete_team_confirm(inputs)
	if (locale === "hi") return hi_admin_delete_team_confirm(inputs)
	if (locale === "ar") return ar_admin_delete_team_confirm(inputs)
	if (locale === "ms") return ms_admin_delete_team_confirm(inputs)
	if (locale === "bn") return bn_admin_delete_team_confirm(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_delete_team_confirm(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_delete_team_confirm(inputs)
	if (locale === "ur") return ur_admin_delete_team_confirm(inputs)
	if (locale === "fa") return fa_admin_delete_team_confirm(inputs)
	if (locale === "sw") return sw_admin_delete_team_confirm(inputs)
	if (locale === "nl") return nl_admin_delete_team_confirm(inputs)
	return en_admin_delete_team_confirm(inputs)
});